{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "צור צוות חדש",
    "HEADER": "צוותים",
    "LOADING": "מאחזר צוותים",
    "DESCRIPTION": "צוותים מאפשרים לך לארגן סוכנים לקבוצות על בסיס תחומי האחריות שלהם. סוכן יכול להשתייך למספר צוותים. בעבודה שיתופית, תוכל להקצות שיחות לצוותים ספציפיים.",
    "LEARN_MORE": "למד עוד על צוותים",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "חפש צוותים...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "לא נוצרו צוותים בחשבון זה.",
      "EDIT_TEAM": "ערוך צוות",
      "NONE": "כלום"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "צור צוות חדש",
        "DESC": "הוסף כותרת ותיאור לצוות החדש שלך."
      },
      "AGENTS": {
        "BUTTON_TEXT": "הוסף סוכנים לצוות",
        "TITLE": "הוסף סוכנים לצוות - {teamName}",
        "DESC": "הוסף סוכנים לצוות החדש שלך שנוצר. זה מאפשר לך לשתף פעולה כצוות בשיחות, לקבל התראות על אירועים חדשים באותה שיחה."
      },
      "WIZARD_CREATE": {
        "TITLE": "צור",
        "BODY": "צור צוות חדש של סוכנים."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "הוסף נציג",
        "BODY": "הוסף סוכנים לצוות."
      },
      "WIZARD_FINISH": {
        "TITLE": "סיים",
        "BODY": "אתם מוכנים לצאת לדרך!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "ערוך את פרטי הצוות שלך",
        "DESC": "ערוך כותרת ותיאור לצוות שלך.",
        "BUTTON_TEXT": "עדכן צוות"
      },
      "AGENTS": {
        "BUTTON_TEXT": "עדכן סוכנים בצוות",
        "TITLE": "הוסף סוכנים לצוות - {teamName}",
        "DESC": "הוסף סוכנים לצוות החדש שלך שנוצר. כל הסוכנים שנוספו יקבלו הודעה כאשר שיחה תוקצה לצוות זה."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "פרטי צוות",
        "ROUTE": "settings_teams_edit",
        "BODY": "שנה שם, תיאור ופרטים נוספים."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "עריכת סוכנים",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "ערוך סוכנים בצוות שלך."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "סיים",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "אתם מוכנים לצאת לדרך!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "לא ניתן לשמור את פרטי הצוות. נסה שוב."
    },
    "AGENTS": {
      "AGENT": "סוכן",
      "EMAIL": "אימייל",
      "BUTTON_TEXT": "הוסף נציגים",
      "ADD_AGENTS": "הוספת סוכנים לצוות שלך...",
      "SELECT": "בחר",
      "SELECT_ALL": "בחר את כל הסוכנים",
      "SELECTED_COUNT": "{selected} מתוך {total} סוכנים שנבחרו."
    },
    "ADD": {
      "TITLE": "הוסף סוכנים לצוות - {teamName}",
      "DESC": "הוסף סוכנים לצוות החדש שלך שנוצר. זה מאפשר לך לשתף פעולה כצוות בשיחות, לקבל התראות על אירועים חדשים באותה שיחה.",
      "SELECT": "בחר",
      "SELECT_ALL": "בחר את כל הסוכנים",
      "SELECTED_COUNT": "{selected} מתוך {total} סוכנים שנבחרו.",
      "BUTTON_TEXT": "הוסף נציגים",
      "AGENT_VALIDATION_ERROR": "בחר סוכן אחד לפחות."
    },
    "FINISH": {
      "TITLE": "הצוות שלך מוכן!",
      "MESSAGE": "עכשיו אתה יכול לשתף פעולה כצוות בשיחות. תמיכה שמח ",
      "BUTTON_TEXT": "סיים"
    },
    "DELETE": {
      "BUTTON_TEXT": "מחק",
      "API": {
        "SUCCESS_MESSAGE": "הצוות נמחק בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן למחוק את הצוות. נסה שוב."
      },
      "CONFIRM": {
        "TITLE": "האם אתה בטוח שברצונך למחוק את הצוות?",
        "PLACE_HOLDER": "אנא הקלד {teamName} כדי לאשר",
        "MESSAGE": "מחיקת הצוות תסיר את הקצאת הצוות מהשיחות שהוקצו לצוות זה.",
        "YES": "מחק ",
        "NO": "ביטול"
      }
    },
    "SETTINGS": "הגדרות",
    "FORM": {
      "UPDATE": "עדכן צוות",
      "CREATE": "צור צוות",
      "NAME": {
        "LABEL": "שם קבוצה",
        "PLACEHOLDER": "דוגמה: מכירות, תמיכת לקוחות"
      },
      "DESCRIPTION": {
        "LABEL": "תיאור צוות",
        "PLACEHOLDER": "תיאור קצר על הצוות הזה."
      },
      "AUTO_ASSIGN": {
        "LABEL": "אפשר הקצאה אוטומטית עבור הצוות הזה."
      },
      "SUBMIT_CREATE": "צור צוות"
    }
  }
}
